import CommonState from '@/class/cargo/model/parameters/CommonState'

export function getCommonState(code, list) {
  for (var common of list) {
    if (common.code === code) {
      return common
    }
  }
  return null
}

/**
 * 更改费用申请状态
 */
export const CHANGE_CHARGE_AWAIT_SUBMIT = new CommonState(0, '待提交', 'Await Submit')
export const CHANGE_CHARGE_AWAIT_JUDGEDUTY = new CommonState(1, '待判责审核', 'Await Judge Duty')
export const CHANGE_CHARGE_AWAIT_BUSINESSAUDIT = new CommonState(2, '待商务审核', 'Await Business Audit')
export const CHANGE_CHARGE_AWAIT_JUDGECLOSED = new CommonState(3, '待关账判定', 'Await Judge Closed')
export const CHANGE_CHARGE_APPROVED = new CommonState(4, '已生效', 'Approved')
export const CHANGE_CHARGE_REJECTED = new CommonState(5, '已拒绝', 'Rejected')
export const CHANGE_CHARGE_REVOKED = new CommonState(6, '已撤销申请', 'Revoked')
export const CHANGE_CHARGE_MANAGER_REVIEW = new CommonState(7, '待经理审核', 'Manager Review')
/**
 * 更改费用申请状态（BPM）
 */
export const CHANGE_CHARGE_UN_APPROVED = new CommonState(21, '未审批', 'un approved')
export const CHANGE_CHARGE_AWAIT_AUDIT = new CommonState(22, '审核中', 'audit')
export const CHANGE_CHARGE_AWAIT_DONE = new CommonState(23, '完成', 'done')
export const CHANGE_CHARGE_AWAIT_BACK_OUT = new CommonState(24, '撤销', 'back out')

export const CHANGE_CHARGE_STATES = new Set([
  CHANGE_CHARGE_AWAIT_SUBMIT,
  CHANGE_CHARGE_AWAIT_JUDGEDUTY,
  CHANGE_CHARGE_AWAIT_BUSINESSAUDIT,
  CHANGE_CHARGE_AWAIT_JUDGECLOSED,
  CHANGE_CHARGE_APPROVED,
  CHANGE_CHARGE_REJECTED,
  CHANGE_CHARGE_REVOKED,
  CHANGE_CHARGE_MANAGER_REVIEW
])

export const CHANGE_CHARGE_STATES_ALL_CODES = [
  CHANGE_CHARGE_AWAIT_SUBMIT.code,
  CHANGE_CHARGE_AWAIT_JUDGEDUTY.code,
  CHANGE_CHARGE_AWAIT_BUSINESSAUDIT.code,
  CHANGE_CHARGE_AWAIT_JUDGECLOSED.code,
  CHANGE_CHARGE_APPROVED.code,
  CHANGE_CHARGE_REJECTED.code,
  CHANGE_CHARGE_REVOKED.code,
  CHANGE_CHARGE_MANAGER_REVIEW.code
]

export const CHANGE_CHARGE_STATES_BPM = new Set([
  CHANGE_CHARGE_AWAIT_AUDIT,
  CHANGE_CHARGE_AWAIT_DONE,
  CHANGE_CHARGE_AWAIT_BACK_OUT
])

export const CHANGE_CHARGE_STATES_BPM_ALL_CODES = [
  CHANGE_CHARGE_AWAIT_AUDIT.code,
  CHANGE_CHARGE_AWAIT_DONE.code,
  CHANGE_CHARGE_AWAIT_BACK_OUT.code
]

/**
 * 费用类型
 */
export const CHANGE_CHARGE_RECEIVABLES = new CommonState(1, '应收', 'Receivables')
export const CHANGE_CHARGE_PAYABLES = new CommonState(0, '应付', 'Payables')

export const CHANGE_CHARGE_CHARGETYPE = new Set([
  CHANGE_CHARGE_RECEIVABLES,
  CHANGE_CHARGE_PAYABLES
])

/**
 * 判责审核结果
 */
export const CHANGE_CHARGE_JUDGEDUTY_YES = new CommonState('1', '有责', 'Responsibility')
export const CHANGE_CHARGE_JUDGEDUTY_NO = new CommonState('0', '无责', 'No responsibility')

export const CHANGE_CHARGE_JUDGEDUTY = new Set([
  CHANGE_CHARGE_JUDGEDUTY_YES,
  CHANGE_CHARGE_JUDGEDUTY_NO
])

/**
 * 商务审核结果
 */
export const CHANGE_CHARGE_BUSINESSAUDIT_AGREE = new CommonState('1', '同意', 'Agree')
export const CHANGE_CHARGE_BUSINESSAUDIT_REFUSE = new CommonState('0', '拒绝', 'Refuse')

export const CHANGE_CHARGE_BUSINESSAUDIT = new Set([
  CHANGE_CHARGE_BUSINESSAUDIT_AGREE,
  CHANGE_CHARGE_BUSINESSAUDIT_REFUSE
])

/**
 * 关账判定
 */
export const CHANGE_CHARGE_JUDGECLOSED_BEFORE = new CommonState('1', '关账前', 'Before')
export const CHANGE_CHARGE_JUDGECLOSED_AFTER = new CommonState('0', '关账后', 'After')

export const CHANGE_CHARGE_JUDGECLOSED = new Set([
  CHANGE_CHARGE_JUDGECLOSED_BEFORE,
  CHANGE_CHARGE_JUDGECLOSED_AFTER
])

/**
 * 申请类型(0=修改;1=新增;2=删除)
 */
export const CHANGE_CHARGE_ACTIONTYPE_CHANGE = new CommonState(0, '申请更改', 'ApplyChange')
export const CHANGE_CHARGE_ACTIONTYPE_ADD = new CommonState(1, '申请新增', 'ApplyAdd')
export const CHANGE_CHARGE_ACTIONTYPE_DELETE = new CommonState(2, '申请删除', 'ApplyDelete')
export const CHANGE_CHARGE_NO = new CommonState(-1, '未改动', 'Unimproved real estate')

export const CHANGE_CHARGE_ACTIONTYPE = new Set([
  CHANGE_CHARGE_ACTIONTYPE_CHANGE,
  CHANGE_CHARGE_ACTIONTYPE_ADD,
  CHANGE_CHARGE_ACTIONTYPE_DELETE,
  CHANGE_CHARGE_NO
])

export const CHANGE_CHARGE_SELECTED_ACTIONTYPE = new Set([
  CHANGE_CHARGE_ACTIONTYPE_CHANGE,
  CHANGE_CHARGE_ACTIONTYPE_ADD,
  CHANGE_CHARGE_ACTIONTYPE_DELETE
])
